import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=5dc5cd5e&scoped=true"
import script from "./EmptyLayout.vue?vue&type=script&lang=js"
export * from "./EmptyLayout.vue?vue&type=script&lang=js"
import style0 from "./EmptyLayout.vue?vue&type=style&index=0&id=5dc5cd5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc5cd5e",
  null
  
)

export default component.exports